module.exports = __webpack_public_path__ + "static/media/navbar_image.145e0621.svg";